/**
 * Which agent and which model are behind a character in the rooms (the owner's ask, 15/10):
 * "Claude Code · Fable 5". Read at a glance, so the model drops what the agent's name already says
 * (the "Claude" family under Claude Code), the runtime (Ollama), the provider path and a date stamp.
 * The server sends display names ("Claude Fable 5", "Ollama Qwen3 1.7b"); agents reporting raw ids
 * ("claude-fable-5", "ollama/qwen3:1.7b") read the same way. Null when the session reported neither.
 */

const NAMES: Record<string, string> = {
  'claude-code': 'Claude Code',
  claude: 'Claude Code',
  codex: 'Codex',
  gemini: 'Gemini CLI',
  opencode: 'OpenCode',
}

function shortModel(model: string): string {
  return model
    .trim()
    .replace(/^ollama[/ ]/i, '')
    .replace(/^claude[- ]/i, '')
    .replace(/-\d{8}$/, '')
}

export function agentLine(session: { providerName: string | null; providerSlug: string | null; modelName: string | null }): string | null {
  const agent = (session.providerSlug ? NAMES[session.providerSlug] : undefined) || session.providerName?.trim() || session.providerSlug || ''
  const model = session.modelName?.trim() ? shortModel(session.modelName) : ''
  if (!agent && !model) return null
  return [agent, model].filter(Boolean).join(' · ')
}
